import { formatRelativeTime, formatDate, formatDateTime } from '@/lib/utils';
import type { CellRendererProps } from './index';

export function DateCell({ value, config }: CellRendererProps) {
  if (value == null || value === '') {
    return <span className="text-sm text-muted-foreground">-</span>;
  }

  const dateStr = String(value);
  const parsed = new Date(dateStr);
  if (isNaN(parsed.getTime())) {
    return <span className="text-sm text-muted-foreground">-</span>;
  }

  const format = (config?.format as string) ?? 'relative';

  let display: string;
  switch (format) {
    case 'relative':
      display = formatRelativeTime(dateStr);
      break;
    case 'short':
      display = formatDate(dateStr);
      break;
    case 'datetime':
      display = formatDateTime(dateStr);
      break;
    case 'full':
      display = formatDate(dateStr, { day: '2-digit', month: 'long', year: 'numeric' });
      break;
    default:
      if (import.meta.env.DEV) {
        console.warn(`[DateCell] Unrecognized format "${format}". Valid: relative, short, datetime, full.`);
      }
      display = formatRelativeTime(dateStr);
  }

  return <span className="text-sm text-muted-foreground">{display}</span>;
}
